import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators, FormsModule } from "@angular/forms";
import { CognitoService } from "src/app/services/cognito.service";
import { DocumentsService } from "src/app/services/document.service";
import { environment } from "src/environments/environment";
import {NotificationsService} from "../../../services/notifications.service";
import Swal from "sweetalert2";
import {UtilsService} from "../../../services/utils.service";
declare var $: any;

@Component({
  selector: "app-entrenadores",
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FormsModule],
  templateUrl: "./entrenadores.component.html",
  styleUrl: "./entrenadores.component.css",
})
export class EntrenadoresComponent implements OnInit {
  loading: boolean = false;
  entrenadores: any;
  dataTable: any;
  infoUser: any
  entrenadorAMostrar: any; //Entrenador seleccionado para mostrar su informacion en modal
  diaNacimiento = this.utilService.days();
  mesNacimiento = this.utilService.months();
  anoNacimiento = this.utilService.years();

  FormTrainer: FormGroup;

  constructor(
    private fb: FormBuilder,
    private documentService: DocumentsService,
    private cognitoService: CognitoService,
    private utilService: UtilsService,
    private notificationsService: NotificationsService
  ) {
    this.FormTrainer = this.fb.group({
      nombre: ["", [Validators.required]],
      sexo: ["", [Validators.required]],
      fechaNacimientoSeparada: this.fb.group({
        dia: ['', [Validators.required]],
        mes: ['', [Validators.required]],
        anio: ['', [Validators.required]]
      }),
      fechaNacimiento: [""],
      email: ["", [Validators.required, Validators.email]],
      //password: ['', [Validators.required,  Validators.minLength(8), this.passwordValidator]],
      //confirmPassword: ['', [Validators.required]],
      lada: [{value:'+52', disabled: false}, [Validators.required, Validators.pattern("^[0-9+]*$")]],
      telefono: [{value:'', disabled:false}, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10)]],
    });
  }

  ngOnInit(): void {
    $('#sidebar-overlay').click();
    this.getTrainers()

    let masterData = JSON.parse(localStorage.getItem('userData'));

    let masterTrainerContainerId = masterData.documentContainerId;
    this.infoUser = masterData;
    console.log(masterData)
    console.log(masterTrainerContainerId)
  }


  createTrainer(){

    if(this.FormTrainer.invalid)
    {
      Swal.fire('Advertencia', 'Verifica que los campos sean válidos.', 'warning');
      return;
    }
    this.loading = true;

    //Generar contraseña aleatoria
    let pass = this.utilService.create_UUID()
    pass = pass.substr(0,7) + "a."
    console.log('password generico', pass)

    let masterData = JSON.parse(localStorage.getItem('userData'));

    let masterTrainerContainerId = masterData.documentContainerId;

    let trainerModel = {
      nombre: this.FormTrainer.value.nombre,
      sexo: this.FormTrainer.value.sexo,
      fechaNacimiento: this.FormTrainer.value.fechaNacimiento,
      email: this.FormTrainer.value.email,
      password: pass,
      telefono: this.FormTrainer.value.lada + this.FormTrainer.value.telefono,
      rol: 'entrenador',
      contenedorPadre: masterTrainerContainerId,
      activo: true,
    }

    this.cognitoService.signUp(
      trainerModel.email,
      trainerModel.email,
      trainerModel.password,
      trainerModel.telefono,
      'entrenador',
      masterTrainerContainerId
    ).then((response) => {
      console.log(response);
      //Si se generó el usuario en cognito, entonces crea el document
      this.documentService.createDocumentInContainer(
          environment.businessId,
          masterTrainerContainerId, //UUID
          trainerModel.email,
          'entrenador',
          null,
          trainerModel
      ).subscribe({
        next: (response: any) => {
          // this.entrenadores.push(response);
          $("#modal-nuevoEntrenador").modal("hide");

          /**** Envío de Email  ****/
          const subject = "Se realizó tu registro a la plataforma 180 fitness";
          const body = `Hola, se realizó el registro de tu usuario para nuestra plataforma 180 fitness. Puedes ingresar utilizando el nombre de usuario ${this.FormTrainer.value.email} y contraseña ${pass}`;
          this.notificationsService.sendEmail(subject, body, this.FormTrainer.value.email).subscribe({
            next: (data) => {
              Swal.fire({
                title: "Cliente creado",
                text: "El cliente ha sido creado correctamente. Se le enviará un correo para confirmar su cuenta.",
                icon: "success",
              })
            },
            error: (error) => {
              console.log(error);
              Swal.fire({
                title: "Error al enviar correo",
                text: "Error al enviar correo.",
                icon: "error",
              })
            },
          });
          /***************************/
          
          this.getTrainers();
          this.loading = false;
        },
        error: (error) => {
          this.loading = false;
          console.log(error);
          // REMOVE IF COGNITO FAILS
          this.entrenadores
        },
        complete: () => {
          this.FormTrainer.reset();
          this.loading = false;
        }
      })
    }).catch((error) => {
      this.loading = false;
      let err = error.toString()
      if(err.includes('User already exists')){
        Swal.fire('Error', 'Ya existe un usuario con este correo. Intente recuperar su contraseña o registre un correo nuevo.', 'error');
      }else{
        console.log(error);
        Swal.fire({
          title: "Error al crear el entrenador",
          text: "Ocurrió un error al crear el entrenador. Por favor, intenta de nuevo.",
          icon: "error",
        })
      }

    })


  }

  getTrainers(){
    let masterData = JSON.parse(localStorage.getItem('userData'));

    let masterTrainerContainerId = masterData.documentContainerId;

    this.documentService.getDocumentsByType(
      environment.businessId,
      masterTrainerContainerId,
      'entrenador'
    ).subscribe({
      next: (response: any) => {
        console.log(response.content);
        this.entrenadores = response.content;
        this.inicializarDataTable()
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  // UTILS

  passwordValidator(control: any): { [key: string]: boolean } | null {
    const password = control.value || '';
    const hasNumber = /\d/.test(password); // Verifica si contiene un número
    const hasUpperCase = /[A-Z]/.test(password); // Verifica si contiene una letra mayúscula
    const hasLowerCase = /[a-z]/.test(password); // Verifica si contiene una letra minúscula

    if (!hasNumber || !hasUpperCase || !hasLowerCase) {
    return { invalidPassword: true };
    }
    return null;
}

  abrirCalendario(input: HTMLInputElement): void {
    input.showPicker(); // Activa el selector de fecha
  }

  modalNuevoEntrenador() {
    this.FormTrainer.reset({
      sexo: '',
      lada: '+52',
    });
    $("#modal-nuevoEntrenador").modal({ backdrop: "static", keyboard: false });
    $("#modal-nuevoEntrenador").modal("show");
  }

  editEntrenadorFn(entrenador){
    let masterData = JSON.parse(localStorage.getItem('userData'));
    let masterTrainerContainerId = masterData.documentContainerId;

    let title = ''
    if(entrenador.activo) title = "Entrenador desactivado con éxito";
    if(!entrenador.activo) title = "Entrenador activado con éxito";

    let trainerModel = {
      nombre: entrenador.nombre,
      sexo: entrenador.sexo,
      fechaNacimiento: entrenador.fechaNacimiento,
      email: entrenador.email,
      password: entrenador.password,
      //telefono: entrenador.lada + entrenador.telefono,
      telefono: entrenador.telefono,
      rol: 'entrenador',
      contenedorPadre: entrenador.contenedorPadre,
      activo: entrenador.activo ? false : true,
    }

    let businessId = environment.businessId;
    let event: any = {}
    this.documentService.updateDocumentInContainer(
        businessId,
        masterTrainerContainerId,
        entrenador.documentId,
        'entrenador',
        event,
        trainerModel
    ).subscribe({
      next: (data) => {
        console.log(data);
        //this.submitFormClases = false;
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: title,
          showConfirmButton: false,
          timer: 1500
        });
        this.getTrainers();
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  inicializarDataTable()
  {
    if (this.dataTable) {
      this.dataTable.destroy(); // Destruir la instancia existente de la DataTable
    }

    $(document).ready(() => {
      this.dataTable = $('#dataTable-listaEntrenadores').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
      });
    });
  }


  printFecha(){
    if (this.FormTrainer.get('fechaNacimientoSeparada.anio')?.value && this.FormTrainer.get('fechaNacimientoSeparada.mes')?.value && this.FormTrainer.get('fechaNacimientoSeparada.dia')?.value) {
      const fecha = `${this.FormTrainer.get('fechaNacimientoSeparada.anio')?.value}-${this.FormTrainer.get('fechaNacimientoSeparada.mes')?.value}-${this.FormTrainer.get('fechaNacimientoSeparada.dia')?.value.padStart(2, '0')}`;
        this.FormTrainer.get('fechaNacimiento')?.setValue(fecha); 
        console.log(fecha);
    }
  }

  showModalEntrenador(entrenador){
    this.entrenadorAMostrar = entrenador;
    console.log(this.entrenadorAMostrar);
    $("#modal-infoEntrenador").modal("show");

  }

}
